import { makeStyles, Typography } from 'beam'
import classNames from 'classnames'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../App/app.reducer'

export const footerMaxWidth = 1200
export const footerMargin = 17

const useStyles = makeStyles(theme => ({
  footer: {
    flex: '0 0 auto',
    width: '100%',
    padding: theme.spacing(1),
    boxSizing: 'border-box',
  },
  fips: {
    marginLeft: '1rem',
  },
  mini: {
    overflow: 'hidden',
    paddingTop: 0,
    paddingBottom: 0,
    height: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  miniText: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2),
  },
  [`@media screen and (max-width: ${footerMaxWidth}px)`]: {
    footer: {
      marginBottom: `${footerMargin}px`,
    },
  },
}))

export interface FooterProps {
  mini?: boolean,
}

const Footer = ({ mini }: FooterProps): ReactElement => {
  const classes = useStyles()
  const { t } = useTranslation()
  const fipsEnabled = useSelector((state: RootState) => state.app.prerequisites?.fipsEnabled ?? false)
  const version = useSelector((state: RootState) => state.app.prerequisites?.version ?? '')
  return mini ? (
    <div className={classNames(classes.footer, classes.mini)}>
      <Typography variant="caption" component="span" className={classes.miniText}>
        {t('calabrioCopyWrite1', { 0: new Date().getFullYear() })}
      </Typography>
    </div>
  ) : (
    <div className={classes.footer}>
      <Typography variant="caption">
        {`${t('version')} ${version}`}
      </Typography>
      {fipsEnabled && (
        <Typography className={classes.fips} variant="caption">
          <strong>{t('fipsEnabled')}</strong>
        </Typography>
      )}
      <Typography display="block" variant="caption">
        {t('calabrioCopyWrite1', { 0: new Date().getFullYear() })}
      </Typography>
      <Typography display="block" variant="caption">
        {t('calabrioCopyWrite')}
      </Typography>
    </div>
  )
}

export default Footer
